package net.sergeych.mptools

import com.ionspin.kotlin.bignum.decimal.BigDecimal

val Number.bd: BigDecimal get() = BigDecimal.parseString(this.toString())
val String.bd: BigDecimal get() = BigDecimal.parseString(this)

fun <T>List<T>.sumOf(f: (T)->BigDecimal): BigDecimal {
    var s = BigDecimal.ZERO
    for( x in this ) s += f(x)
    return s
}